import SchedulesListItem from './SchedulesListItem';

export default SchedulesListItem;
